<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-container v-bind="{ [`grid-list-${size}`]: true }" fluid>
          <!-- <v-layout wrap xs12>
            <v-flex> Active Types </v-flex>
          </v-layout> -->
          <v-layout wrap xs12>
            <v-flex v-for="typecode in getActiveTypeCodes()" :key="typecode.code" xs6 sm4 md2>
              <v-hover>
                <v-card slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 2}`"
                        color="var(--panel-background)"
                        @click.native="setupNewSystem(typecode)"
                        style="height: 100%; cursor: pointer">
                <v-img :src="typecode.logo250"></v-img>
                  <v-card-title class="justify-center type-tile-title"><span>{{getDescription(typecode)}}</span></v-card-title>
              </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
          <v-layout wrap xs12>
            <v-flex style="border: 1px solid grey;font-size: 16px;font-weight: 600;">
              Please contact your account team to use any of the following system types:
            </v-flex>
          </v-layout>
          <v-layout wrap xs12>
            <v-flex v-for="typecode in getInactiveTypeCodes()" :key="typecode.code" xs6 sm4 md2>  
                <v-card color="var(--panel-background)" style="height: 100%;position: relative;">
                    <v-img :src="typecode.logo250"
                    style="-webkit-filter: grayscale(100%); filter: grayscale(100%);"
                    ></v-img>
                  <v-card-title class="justify-center type-tile-title"><span>{{getDescription(typecode)}}</span></v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  data(){
      return {
          size: 'xl'
      }
  },
  computed: {
    ...mapState({
      typecodes: state => state.systems.typeCodes
    }),
    ...mapGetters('systems', {
      systems: 'allSystems'
    })
  },
  async created () {
    await this.$store.dispatch('systems/getTypeCodes');
  },
  methods: {
      async setupNewSystem (typecode) {
        await this.$store.dispatch("systems/setupNewSystem", typecode);
        this.$router.replace({ name: "newsysconfig" });
      },
      getActiveTypeCodes() {
        let typecodes = _.sortBy(_.filter(this.typecodes, {isActive: true}), ['description']);
        return typecodes;
      },
      getInactiveTypeCodes() {
        let typecodes = _.sortBy(_.filter(this.typecodes, {isActive: false}), ['description']);
        return typecodes;
      },
      isOAuthItem(item) {
        if (item.code === 'CUSTOM') {
          return true
        }
        if (item.isOAuth) {
          return _.isNil(item.configs.useOAuth) || (item.configs.useOAuth === true) || (item.configs.useOAuth === 'true')
        }
        return false
      },
      getDescription(typecode)  {
        let desc = typecode.description
        return desc
      }
  }
}
</script>

<style scoped>
  .type-tile-title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }
</style>
